import React from 'react'
import { CheckIcon, ChevronDownIcon } from '../../assets/icons'
import { landingContent } from '../../config/content.config'
import Badge from '../Badge/Badge'
import Button from '../Button/Button'
import TradeArrow from '../TradeArrow/TradeArrow'
import './Hero.css'

const Hero = () => {
  const { hero } = landingContent

  const scrollToFeatures = () => {
    const element = document.querySelector('#features')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section id="home" className="hero">
      {/* Background Elements */}
      <div className="hero-grid"></div>
      <TradeArrow className="hero-geometric-shape" />

      <div className="hero-inner">
        {/* Header section with badge and title spanning full width */}
        <div className="hero-header">
          <Badge className="hero-badge">{hero.label}</Badge>
          <h1 className="section-title hero-title">{hero.title}</h1>
        </div>

        {/* Content section with text on left and image on right */}
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-subtitle">{hero.subtitle}</p>

            <div className="hero-features">
              {hero.features.map((feature, index) => (
                <div key={index} className="hero-feature">
                  <CheckIcon className="hero-feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="hero-cta">
              <Button
                href={hero.cta.primary.href}
                className="hero-btn-primary"
                onClick={(e) => {
                  e.preventDefault()
                  scrollToFeatures()
                }}
              >
                {hero.cta.primary.label}
              </Button>
              <Button
                href={hero.cta.secondary.href}
                variant="secondary"
                className="hero-btn-secondary"
                onClick={(e) => {
                  e.preventDefault()
                  const element = document.querySelector(
                    hero.cta.secondary.href,
                  )
                  if (element) element.scrollIntoView({ behavior: "smooth" })
                }}
              >
                {hero.cta.secondary.label}
              </Button>
            </div>

            <div className="hero-stats">
              {hero.stats.map((stat, index) => (
                <div key={index} className="card hero-stat">
                  <div className="hero-stat-value">{stat.value}</div>
                  <div className="hero-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-image-wrapper">
              <img
                src={hero.image.src}
                alt={hero.image.alt}
                className="hero-image"
              />
              <div className="hero-image-overlay"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="scroll-indicator"
        onClick={scrollToFeatures}
        role="button"
        tabIndex={0}
        aria-label={hero.scrollLabel}
      >
        <span>{hero.scrollLabel}</span>
        <ChevronDownIcon />
      </div>
    </section>
  )
}

export default Hero
